import React from 'react';
import styles from './avatar.module.scss';
import cx from 'classnames';

type Props = {
  image: string | null | undefined;
  size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
  type?: 'circle' | 'square';
  fallback?: string; // path to relative public position
  className?: string;
  tabIndex?: number;
};
const Avatar = (props: Props) => {
  const { image, size = 'sm', type = 'circle', fallback, className, tabIndex } = props;

  const classNames = cx(styles.avatar, styles[type], styles[size], className);

  return (
    <div tabIndex={tabIndex} className={classNames}>
      {image && <img src={image} alt="avatar" />}
      {!image && fallback && <img src={fallback} alt="avatar" />}
    </div>
  );
};

export default Avatar;
